module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "value-action-duplicate"
  }, [_c('i', {
    staticClass: "icon yule-icon-duplicate",
    attrs: {
      "title": _vm.$t('models.external_form.duplicate_desc')
    },
    on: {
      "click": _vm.duplicate
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "value-action-pending"
  }, [_c('i', {
    staticClass: "icon yule-icon-clock",
    attrs: {
      "title": _vm.$t('models.external_form.pending_cloning')
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2286fa1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueActionDuplicate.vue
// module id = 1838
// module chunks = 0